import fetch from 'isomorphic-unfetch';
import config from '../config';

const { apiHost } = config;
// eslint-disable-next-line import/prefer-default-export
export async function getLangFile() {
    const langFile = await fetch(`${apiHost}/v1/config/FetchLangFile`);
    return langFile;
}
